module.exports = __webpack_public_path__ + "static/media/number.a5378454.svg";